import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { map } from 'rxjs/operators';
import { createHttpParams } from '~/infrastructure/http/params';
import { augmentPaging } from '~/infrastructure/paging';
import { BarcodeGeneratorSummary } from '~/models/modules/barcodeGenerator';
import { ApiServiceBase, API_NAMES } from '~/services/api';

@Injectable({ providedIn: 'root' })
export class BarcodeGeneratorsService extends ApiServiceBase {
  constructor(injector: Injector, private http: HttpClient) {
    super(injector);
    this.setBase(API_NAMES.settings);
  }

  getBarcodeEnabled(entityName: string) {
    return this.http.get<string>(this._url(`/${entityName}/enabled`));
  }

  getBarcode(entityName: string, quantity: any) {
    quantity = parseInt(quantity);
    return this.http.get<boolean[]>(this._url(`/${entityName}/${quantity}/entity-sequence`));
  }

  getBarcodeGenerators(paramsObj?: any, model?: any) {
    paramsObj = paramsObj || {};
    paramsObj.view = 'summary';
    let params = createHttpParams(paramsObj);

    return this.http
      .post<BarcodeGeneratorSummary[]>(this._url(`/grid-data`), model, {
        params,
        observe: 'response',
      })
      .pipe(map(augmentPaging));
  }

  getBarcodeGenerator(id: number) {
    return this.client.get<BarcodeGeneratorSummary>(this._url(`/${id}`));
  }

  updateBarcodeGenerator(id: number, model: any) {
    return this.client.put(this._url(`/${id}`), model);
  }

  getEnabledBarcodeGenerators() {
    return this.client.get<BarcodeGeneratorSummary[]>(this._url());
  }
  GetBarcodeGeneratorsWithEntityBaseId(EntityBaseIds: number[]) {
    return this.client.post<BarcodeGeneratorSummary[]>(this._url(`/GetBarcodeGeneratorsWithEntityBaseId`), EntityBaseIds);
  }


  private _url(v?: string | undefined) {
    v = v || '';
    return this.url(`/BarcodeGenerators${v}`);
  }
}
